var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_paypal",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.381,
    height: 18.452,
    viewBox: "0 0 68.381 18.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M355.418,221.2h-5.272a1.03,1.03,0,0,0-.775.62L347.2,235.465a.411.411,0,0,0,.465.465h2.791a.411.411,0,0,0,.465-.465l.62-3.876a.709.709,0,0,1,.775-.62h1.706q5.349,0,6.047-5.117a4.064,4.064,0,0,0-.62-3.411,6.254,6.254,0,0,0-4.032-1.241m.62,5.117c-.31,1.861-1.706,1.861-3.1,1.861h-.93l.62-3.566c0-.155.155-.31.465-.31h.31c.93,0,1.861,0,2.326.62.31.155.31.62.31,1.4",
    transform: "translate(-309.211 -221.2)",
    fill: "#139ad6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M159.418,221.2h-5.272a1.03,1.03,0,0,0-.775.62L151.2,235.465a.411.411,0,0,0,.465.465h2.481a1.03,1.03,0,0,0,.775-.62l.62-3.721a.709.709,0,0,1,.775-.62h1.706q5.35,0,6.047-5.117a4.064,4.064,0,0,0-.62-3.411,5.96,5.96,0,0,0-4.032-1.241m.62,5.117c-.31,1.861-1.706,1.861-3.1,1.861h-.775l.62-3.566c0-.155.155-.31.465-.31h.31c.93,0,1.861,0,2.326.62a1.661,1.661,0,0,1,.155,1.4",
    transform: "translate(-151.2 -221.2)",
    fill: "#263b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M225.936,245.51h-2.481c-.155,0-.465.155-.465.31l-.155.775-.155-.31a3.647,3.647,0,0,0-2.946-1.085A5.958,5.958,0,0,0,214,250.317a4.622,4.622,0,0,0,.93,3.876,3.907,3.907,0,0,0,3.256,1.24,4.956,4.956,0,0,0,3.566-1.4l-.155.775a.411.411,0,0,0,.465.465h2.326a1.03,1.03,0,0,0,.775-.62l1.4-8.683c-.155-.155-.465-.465-.62-.465m-3.566,4.962a3,3,0,0,1-2.946,2.481,2.48,2.48,0,0,1-1.706-.62,3.307,3.307,0,0,1-.465-1.861,2.766,2.766,0,0,1,4.5-1.861,2.707,2.707,0,0,1,.62,1.861",
    transform: "translate(-201.746 -240.548)",
    fill: "#263b80"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M421.135,245.51h-2.481c-.155,0-.465.155-.465.31l-.155.775-.155-.31a3.647,3.647,0,0,0-2.946-1.085,5.958,5.958,0,0,0-5.737,5.117,4.622,4.622,0,0,0,.93,3.876,3.908,3.908,0,0,0,3.256,1.24,4.956,4.956,0,0,0,3.566-1.4l-.155.775a.411.411,0,0,0,.465.465h2.326a1.03,1.03,0,0,0,.775-.62l1.4-8.683c-.155-.155-.31-.465-.62-.465m-3.566,4.962a3,3,0,0,1-2.946,2.481,2.48,2.48,0,0,1-1.706-.62,3.307,3.307,0,0,1-.465-1.861,2.766,2.766,0,0,1,4.5-1.861,1.78,1.78,0,0,1,.62,1.861",
    transform: "translate(-359.112 -240.548)",
    fill: "#139ad6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M295.94,246.8H293.3a.806.806,0,0,0-.62.31l-3.411,5.272-1.551-4.962a.716.716,0,0,0-.775-.465h-2.481c-.31,0-.465.31-.465.62l2.791,8.218-2.636,3.721c-.155.31,0,.775.31.775h2.481a.805.805,0,0,0,.62-.31l8.528-12.25c.465-.465.155-.93-.155-.93",
    transform: "translate(-258.26 -241.838)",
    fill: "#263b80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M477.371,222.057,475.2,236.012a.411.411,0,0,0,.465.465h2.171a1.03,1.03,0,0,0,.775-.62l2.171-13.645a.411.411,0,0,0-.465-.465h-2.481c-.155-.155-.31,0-.465.31",
    transform: "translate(-412.401 -221.592)",
    fill: "#139ad6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.978b63bd6b602c5f792fc5ad044388e9.svg";
export { ForwardRef as ReactComponent };